module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 20 20\"><rect width=\"7\" height=\"7\" x=\"2\" y=\"2\" data-name=\"Rectangle 31\" rx=\"2\"></rect><rect width=\"7\" height=\"7\" x=\"2\" y=\"11\" data-name=\"Rectangle 34\" rx=\"2\"></rect><rect width=\"7\" height=\"7\" x=\"11\" y=\"2\" data-name=\"Rectangle 32\" rx=\"2\"></rect><rect width=\"7\" height=\"7\" x=\"11\" y=\"11\" data-name=\"Rectangle 33\" rx=\"2\"></rect></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/offer-type.svg
// module id = 248
// module chunks = 1